import React from "react";

export const convertDate = (submittedDate) => {
  let date = new Date(submittedDate);
  //let date = convertDateAsUTC(submittedDate);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  hours = hours > 9 ? hours : `0${hours}`;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  let strTime = hours + ":" + minutes + " " + ampm;
  let month =
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
  let formattedDate =
    date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate();
  let finalDate = `${month}/${formattedDate}/${date.getFullYear()} ${strTime}`;
  return finalDate;
};

export const convertDateAsUTC = (date) => {
  const dt = new Date(date);
  return new Date(
    dt.getUTCFullYear(),
    dt.getUTCMonth(),
    dt.getUTCDate(),
    dt.getUTCHours(),
    dt.getUTCMinutes(),
    dt.getUTCSeconds()
  );
};

export const formatDate = (submittedDate, format = "mm/dd/yyyy") => {
  let date = new Date(submittedDate);
  let month =
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
  let formattedDate =
    date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate();
  let finalDate = "";
  if (format === "mm/dd/yyyy") {
    finalDate = `${month}/${formattedDate}/${date.getFullYear()}`;
  } else {
    finalDate = `${formattedDate}/${month}/${date.getFullYear()}`;
  }
  
  return finalDate;
};
